import IconButton from '@/components/Buttons/IconButton';
import BootstrapDialog from '@/components/Dialog/BootstrapDialog';
import { StyleCollection } from '@/utils/types';
import styled from '@emotion/styled';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Button } from '@mui/material';

interface Props {
    open: boolean;
    isLoading?: boolean;
    onPrimaryAction: () => Promise<void> | void;
    primaryActionContent: any;
    onClose: (event: any, reason: string) => void;
    content: any;
    styles?: StyleCollection;
    buttonPlacement?: 'start' | 'end' | 'center';
}

const StyledButton = styled(Button)`
    border-radius: 8px;
    background: var(--primary-main, ${({ theme }) => theme.colors.primary.main});
    backdrop-filter: blur(60px);
    display: flex;
    height: 44px;
    padding: 0px 8px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    color: var(--primary-black-0, var(--Black-0, #fffefd));
    text-align: center;
    font-family: Mulish;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    margin-top: 10px;
    text-transform: none;

    &:hover {
        background: var(--primary-dark, ${({ theme }) => theme.colors.primary.hover});
    }
`;

const StyledDialog = styled(BootstrapDialog)`
    & .MuiPaper-root {
        border-radius: 20px;
    }
`;

const Body = styled.div`
    display: flex;
    height: 175px;
    width: 450px;
    color: var(--text-primary-dark, #28282b);
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.48px;
    display: inline-flex;
    padding: 24px 40px;
    flex-direction: column;
    align-items: flex-end;
    gap: 16px;
    border-radius: 20px;
    background: #fff;
`;

const StyledIconButton = styled(IconButton)`
    width: 30px;
    height: 30px;
    border-radius: 50%;
    top: 15px;
    right: 15px;
    position: absolute;
`;

export default function ({ content, open, onPrimaryAction: onAction, primaryActionContent, onClose, isLoading }: Props) {
    return (
        <StyledDialog onClose={onClose} open={open}>
            <StyledIconButton ariaLabel="close" onClick={onAction}>
                <HighlightOffIcon sx={{ fontSize: '38px', color: '#222222' }} />
            </StyledIconButton>
            <Body>
                {content}
                <StyledButton onClick={onAction} disabled={isLoading}>
                    {primaryActionContent}
                </StyledButton>
            </Body>
        </StyledDialog>
    );
}
